
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { getStripe3DSSettings } from "@MasterBluePrint/Store/Context/ContextSelector";

import { getClientSecret } from "@MasterBluePrint/Services/PaymentService";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

declare global { interface Window { Stripe: any; } }

interface OwnProps {
    paymentMethod: any;
    submitStripe3DS: boolean;
    handleStripe3DSSubmit: any;
    handleStripe3DSResponse: any;
}
export interface Stripe3dsStyles {
    loadingSpinner?: LoadingSpinnerProps;
}
export const stripe3dsStyles: Stripe3dsStyles = {
    loadingSpinner: {
        css: css`
            margin: auto;
        `,
    },
};

const styles = stripe3dsStyles;

const mapStateToProps = (state: ApplicationState) => {
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
    const stripe3DSSetting = getStripe3DSSettings(state);
    return {
        cartState,
        session: state.context.session,
        publishableKey: stripe3DSSetting?.stripePublishableKey,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;
type Stripe = any;
type StripeElements = any;
type StripeError = any;
const Stripe3DS = ({
    publishableKey,
    cartState,
    session,
    paymentMethod,
    submitStripe3DS,
    handleStripe3DSSubmit,
    handleStripe3DSResponse,
}: Props) => {
    const [loadIframe, setLoadIframe] = useState(false);
    const [clientSecret, setClientSecret] = useState("");
    const [message, setMessage] = React.useState("");
    const [error, setError] = React.useState<StripeError>();
    const [stripe, setStripe] = React.useState<Stripe>(null);
    const [elements, setElements] = React.useState<StripeElements>(null);

    useEffect(() => {
        if (submitStripe3DS) {
            handleSubmit();
        }
    }, [submitStripe3DS]);


    const handleSubmit = async () => {

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        await stripe
            .confirmPayment({
                elements,
                redirect: "if_required",
            })
            .then((response: any) => {
                handleStripe3DSResponse(response);
                if (response.error) {
                    handleStripe3DSSubmit(false);
                    setError(response.error);
                }
            });

        if (error && (error.type === "card_error" || error.type === "validation_error")) {
            setMessage(error.message ?? "");
            // handleStripe3DSFormSubmit(false);
        } else if (error) {
            setMessage("An unexpected error occured.");
        }
    };

    const getSecret = async () => {
        try {
            const response = await getClientSecret(cartState.value?.orderGrandTotal, session.currency!.currencyCode);
            if (!response.clientSecret) {
                handleStripe3DSSubmit(false);
                setMessage("Failed to load Stripe 3DS iframe.");
                throw new Error("Data could not be fetched!");
            } else {
                return response;
            }
        } catch (err) {
            handleStripe3DSSubmit(false);
            setMessage("Failed to load Stripe 3DS iframe.");
            console.error(err);
        }
    };


    useEffect(() => {
        if (publishableKey && typeof window !== "undefined") {
            getSecret()
                .then(res => {
                    setClientSecret(res.clientSecret);
                })
                .catch(e => {
                    handleStripe3DSSubmit(false);
                    setMessage("Failed to load Stripe 3DS iframe.");
                    console.error(e);
                }).finally(() => {

                });

        }
    }, [publishableKey]);


    useEffect(() => {
        if (clientSecret && !cartState.isLoading) {            
            if(window.Stripe)
            {
                const stripe = window.Stripe(publishableKey);
                setStripe(stripe);
                const elements = stripe.elements({
                    clientSecret,
                });
                setElements(elements);
                const paymentElement = elements.create("payment");
                paymentElement.mount("#payment-element");
                setLoadIframe(true);
            }           
        }
    }, [clientSecret, cartState.isLoading]);


    return (
        <>
            {!loadIframe && <LoadingSpinner {...styles.loadingSpinner} />}
            <>
                <div>
                    <div id="payment-element"></div>
                </div>
                {message && <div id="payment-message">{message}</div>}
            </>
        </>
    );
};

// eslint-disable-next-line spire/export-styles
export default connect(mapStateToProps)(Stripe3DS);


